<template>
  <div class="video-wrapper" :class="height > width ? 'vertical' : ''">
    <div class="video">
      <FileLimitDesc v-bind="videoInfo">
        <template slot="btn">
          <el-button type="primary" @click="$emit('upload', 'video')">选择视频</el-button>
        </template>
      </FileLimitDesc>

      <el-tag class="badge">视频{{ index + 1 }}</el-tag>

      <!-- <video style="height: 100%" preload="metadata" :src="$attrs.url"></video> -->
      <img style="height: 100%" v-if="$attrs.preview_url" :src="$attrs.preview_url" alt="" />
      <div class="asset-name">
        <!-- <p>
          <el-tag type="info">{{ $attrs.id }}</el-tag>
        </p> -->
        <p v-if="width">
          <el-tag type="info">{{ width }}&times;{{ height }}</el-tag>
        </p>
        <p v-if="size">
          <el-tag type="info">{{ (size / 1024 / 1024).toFixed(2) }}M</el-tag>
        </p>
        <p>
          <el-tag type="info">{{ $attrs.name }}</el-tag>
        </p>
      </div>
    </div>

    <div class="poster" v-if="posterInfo">
      <FileLimitDesc v-bind="posterInfo">
        <template slot="btn">
          <el-button type="primary" @click="$emit('upload', 'poster')">选择封面</el-button>
        </template>
      </FileLimitDesc>
      <img style="height: 100%" :src="$attrs.replaced_cover_url || $attrs.cover_url" alt="" />
      <i class="remove el-icon-error" @click="$emit('remove')"></i>

      <div class="asset-name">
        <p v-if="cover_width">
          <el-tag type="info">{{ cover_width }}&times;{{ cover_height }}</el-tag>
        </p>
        <p v-if="cover_size">
          <el-tag type="info">{{ (cover_size / 1024 / 1024).toFixed(2) }}M</el-tag>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import FileLimitDesc from './material-desc.vue'
export default {
  components: { FileLimitDesc },
  props: ['size', 'width', 'height', 'cover_height', 'cover_width', 'cover_size', 'index'],
  data() {
    return {}
  },
  computed: {
    posterInfo() {
      return {
        description: '视频封面',
        width: this.cover_width,
        height: this.cover_height,
        file_size: 1024 * 1,
        file_format: ['JPG', 'PNG']
      }
    },
    videoInfo() {
      return {
        description: '视频',
        width: this.width,
        height: this.height,
        file_size: 1024 * 200,
        file_format: ['MP4']
      }
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
@import './styles.scss';
</style>
